module.exports = __webpack_public_path__ + "static/media/landing_strestrac.60763f48.png";